import { Helmet } from "react-helmet-async";

/**
 * BrandSchema component that adds consistent brand entity markup
 * This helps Google recognize RandomGen as a specific brand
 */
export const BrandSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Brand",
    "name": "RandomGen",
    "alternateName": ["Random Number Generator", "numbers-generator.com"],
    "url": "https://numbers-generator.com/",
    "logo": "https://numbers-generator.com/icon-512.png",
    "description": "Free cryptographically secure random number generator - the leading alternative to Random.org with instant results, no ads, and advanced features for lotteries, games, and statistical analysis.",
    "slogan": "Free Random Number Generator - Cryptographically Secure RNG"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
